export default "__VITE_ASSET__DR2i_5FD__"